 <div class="RegContainer mt-1">
     <h1>Регистрация куратора предприятия</h1>
     <form [formGroup]="curatorForm">
         <label style="color: red" *ngIf="blockExist">Такая организация уже зарегистрирована</label><br>
         <label>Наименование предприятия</label>
         <span style="color: red" *ngIf="curatorForm.get('BlockName').errors && curatorForm.get('BlockName').hasError('required')">*</span>
         <ngx-dadata formControlName="BlockName" placeholder="Укажите наименование организации либо ИНН и выберите Ваше предприятие из списка" [config]="config" (input)="changeBlock($event)" (selected)="updateinn($event)"></ngx-dadata>
         <span style="color: red" *ngIf="validName">Обязательное поле</span><br *ngIf="validName">

         <label>ИНН Организации (заполняется автоматически)</label>
         <span *ngIf="curatorForm.get('Inn').errors && curatorForm.get('Inn').hasError('required')" style="color: red">*</span>
         <input class="form-control" formControlName="Inn" type="text" placeholder="ИНН Организации" disabled />
         <span style="color: red" *ngIf="validInn">Обязательное поле</span><br *ngIf="validInn">

         <label>Госкорпорация/Холдинг/Управляющая компания/другое (при наличии)</label>
         <ngx-dadata formControlName="holding" placeholder="Укажите головную организацию, куда входит предприятие" [config]="config"></ngx-dadata>

         <label>ФИО куратора от предприятия</label>
         <span *ngIf="
         curatorForm.get('firstName').errors &&
         curatorForm.get('firstName').hasError('required') ||
         curatorForm.get('lastName').errors &&
         curatorForm.get('lastName').hasError('required') ||
         curatorForm.get('middleName').errors &&
         curatorForm.get('middleName').hasError('required')
            " style="color: red">*</span>
         <div class="row justify-content-center">
             <input style="max-width: 235px" formControlName="lastName"  class="form-control mr-2" placeholder="Укажите фамилию куратора" />
             <input style="max-width: 200px" formControlName="firstName" class="form-control mr-2" placeholder="Укажите имя куратора" />
             <input style="max-width: 230px" formControlName="middleName" class="form-control" placeholder="Укажите отчество куратора" />
         </div>
         <span style="color: red" *ngIf="validFIO">Обязательные поля</span><br *ngIf="validFIO">

         <label>Телефон куратора</label>
         <span style="color: red" *ngIf="!(phoneInputComponent.phoneValueWithRegion.length > 10)">*</span>
         <app-phone-input>
         </app-phone-input>
         <span style="color: red" *ngIf="validPhone">Обязательное поле</span><br *ngIf="validPhone">

         <br>
         <label>Почта куратора</label>
         <span *ngIf="
         curatorForm.get('email').errors &&
         curatorForm.get('email').hasError('required') ||
         curatorForm.get('email').hasError('email')" style="color: red">*</span>
         <br>
         <label>Пароль для входа в систему будет отправлен на указанный email</label>
         <input class="form-control" formControlName="email" type="text" placeholder="example@org.ru" />
         <span style="color: red" *ngIf="validEmail">Обязательное поле</span><br *ngIf="validEmail">

         <br>
         <input type="checkbox" hidden="true" formControlName="isRacOrg" style="width: 15px; height: 15px" class="mr-2" id="isRacOrg"/>

         <input type="checkbox" formControlName="userAgreement" style="width: 15px; height: 15px" class="mr-2" id="userAgreement"/><label for="userAgreement">Я принимаю <a href="themes/default/assets/documents/Пользовательское_соглашение_Конкурс_last.pdf" target="_blank">Пользовательское соглашение</a></label>
         <span *ngIf="curatorForm.get('userAgreement').errors || curatorForm.get('userAgreement').hasError('requiredTrue')" style="color: red">*</span>
         <br *ngIf="validUserAgreement"><span style="color: red" *ngIf="validUserAgreement">Обязательное поле</span>
         <br>

         <input type="checkbox" formControlName="personalData" style="width: 15px; height: 15px" class="mr-2" id="personalData"/><label for="personalData">Я соглашаюсь с <a href="themes/default/assets/documents/Согласие%20ПнД.pdf" target="_blank">Политикой обработки персональных данных</a></label>
         <span *ngIf="curatorForm.get('personalData').errors || curatorForm.get('personalData').hasError('requiredTrue')" style="color: red">*</span>
         <br *ngIf="validPersonalData"><span style="color: red" *ngIf="validPersonalData">Обязательное поле</span>
         <br>
         <app-captcha #captchaComponent></app-captcha>
         <input id="captchaCode"
                name="captchaCode"
                [(ngModel)]="captchaCode"
                class="form-control"
                autocomplete="off"
                placeholder="{{ 'Common.CaptchaText' | translate }}"
                type="text" [ngModelOptions]="{standalone: true}"/>
         <br *ngIf="invalidCaptcha"><span style="color: red" *ngIf="invalidCaptcha">Неверно. Попробуйте еще раз!</span>
         <br>
         <div class="col text-center">
             <button [disabled]="lockSubmitButton" type="button" class="btn btn-primary" (click)="submitRegistration()">Зарегистрироваться</button>
         </div>
     </form>
 </div>
